import { APIcallerv2 } from './APIcaller';

const getWeatherForecastStation = (storeLocation) =>
  APIcallerv2.apiGet(`/forecasts/weather-station`, { storeLocation });

export const weatherStation = {
  getWeatherForecastStation,
};
